<div [formGroup]="form">
  <mojo-select
    class="configured status-assign"
    [multiple]="true"
    [options]="statuses"
    [disableOptionCentering]="true"
    [disableRipple]="true"
    panelClass="status-select"
    [color]="'secondary'"
    [isDisabled]="isDisabled"
    (selection)="selectionChange($event)"
    formControlName="filter"
  >
  </mojo-select>
</div>
